<template>
    <div class="flex font-normal items-center text-gray-700 tracking-wide" :class="{ 'text-base': size === 'base', 'text-lg': size === 'lg' }">
        <div class="bg-blue-500 flex h-6 items-center justify-center mr-2 rounded-full w-6" style="padding: 0.35rem;">
            <svg class="block fill-current h-6 text-white w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"></path>
            </svg>
        </div>
        {{ $t('globals.budgets') }}
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: 'base',
        },
    },
};
</script>
